export const home = {
  'Made for': 'Créé pour',
};
